import { Component, OnInit } from '@angular/core';
import { BaseUpdateComponent, BaseDataService, NotificationService } from 'yt-ng-framework';
import { Proizvodjac } from './proizvodjac';
import { ActivatedRoute } from '@angular/router';
// import { NotificationsService } from 'angular2-notifications';
import { TranslateService } from '@ngx-translate/core';
import { Validators } from '@angular/forms';
// import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'yt-proizvodjac-update',
  templateUrl: './proizvodjac-update.component.html'
})
export class ProizvodjacUpdateComponent extends BaseUpdateComponent<Proizvodjac> implements OnInit {

  constructor(
    protected activatedRoute: ActivatedRoute,
    protected baseDataService: BaseDataService,
    // protected notificationsService: NotificationsService,
    protected toastrService: NotificationService,
    protected translateService: TranslateService
  ) {
    super(activatedRoute, baseDataService, toastrService, translateService);
  }

  ngOnInit() {
    super.ngOnInit();
    this.addValidatorToFc('Naziv', Validators.required, 'required', 'PROIZVODJAC.NAZIV.VALIDATION.REQUIRED');
    this.addValidatorToFc('Naziv', Validators.maxLength(50), 'required', 'PROIZVODJAC.NAZIV.VALIDATION.MAXLENGTH');

  }

}
